
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
"use strict";
var $a5fd07fa01589658$exports = {};

$parcel$export($a5fd07fa01589658$exports, "Game", function () { return $a5fd07fa01589658$export$985739bfa5723e08; });
"use strict";
class $a5fd07fa01589658$export$985739bfa5723e08 {
    /**
   * Creates a new game instance.
   *
   * @param {number[][]} initialState
   * The initial state of the board.
   * @default
   * [[0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0]]
   *
   * If passed, the board will be initialized with the provided
   * initial state.
   */ constructor(initialState = [
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ]
    ]){
        this.initialState = initialState;
        this.score = 0;
        this.state = [
            ...this.initialState
        ];
        this.status = "idle";
    }
    moveLeft() {
        const newState = [];
        let canMove = false;
        for(let i = 3; i >= 0; i--){
            const row = this.state[i].filter((number)=>number !== 0);
            for(let n = 1; n < row.length; n++)if (row[n] === row[n - 1]) {
                row[n - 1] *= 2;
                delete row[n];
                this.score += row[n - 1];
            }
            const newRow = row.filter((number)=>number !== undefined);
            for(let j = newRow.length; j < 4; j++)newRow.push(0);
            newState[i] = newRow;
        }
        for(let i = 0; i <= 3; i++){
            for(let n = 0; n <= 3; n++)if (newState[i][n] !== this.state[i][n]) canMove = true;
        }
        if (canMove) {
            this.state = newState;
            this.addCell();
        }
        this.checkLose();
        this.checkWin();
    }
    moveRight() {
        const newState = [];
        let canMove = false;
        for(let i = 3; i >= 0; i--){
            const row = this.state[i].filter((number)=>number !== 0);
            for(let n = row.length - 1; n >= 0; n--)if (row[n] === row[n - 1]) {
                row[n] *= 2;
                row[n - 1] = 0;
                this.score += row[n];
            }
            const newRow = row.filter((number)=>number !== 0);
            for(let j = newRow.length; j < 4; j++)newRow.unshift(0);
            newState[i] = newRow;
        }
        for(let i = 0; i <= 3; i++){
            for(let n = 0; n <= 3; n++)if (newState[i][n] !== this.state[i][n]) canMove = true;
        }
        if (canMove) {
            this.state = newState;
            this.addCell();
        }
        this.checkLose();
        this.checkWin();
    }
    moveUp() {
        this.state = this.turnTable(this.state);
        this.moveLeft();
        this.state = this.turnTable(this.state);
    }
    moveDown() {
        this.state = this.turnTable(this.state);
        this.moveRight();
        this.state = this.turnTable(this.state);
    }
    /**
   * @returns {number}
   */ getScore() {
        return this.score;
    }
    /**
   * @returns {number[][]}
   */ getState() {
        return this.state;
    }
    /**
   * Returns the current game status.
@@ -50,19 +157,101 @@ class Game {
   * `win` - the game is won;
   * `lose` - the game is lost
   */ getStatus() {
        return this.status;
    }
    /**
   * Starts the game.
   */ start() {
        this.status = "playing";
        this.addCell();
        this.addCell();
    }
    /**
   * Resets the game.
   */ restart() {
        this.status = "idle";
        this.state = [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.score = 0;
    }
    addCell() {
        const initial = Math.random() > 0.1 ? 2 : 4;
        let count = 0;
        do {
            const row = Math.round(Math.random() * 3);
            const column = Math.round(Math.random() * 3);
            if (this.state[row][column] === 0) {
                this.state[row][column] = initial;
                count++;
            }
        }while (count < 1);
    }
    turnTable(table) {
        const newTable = [];
        for(let i = 0; i <= 3; i++){
            const newRow = [
                table[0][i],
                table[1][i],
                table[2][i],
                table[3][i]
            ];
            newTable.push(newRow);
        }
        return newTable;
    }
    checkWin() {
        for(let i = 0; i <= 3; i++){
            for(let n = 0; n <= 3; n++)if (this.state[i][n] === 2048) this.status = "win";
        }
    }
    checkLose() {
        for(let i = 0; i < 4; i++)for(let j = 0; j < 4; j++){
            if (this.state[i][j] === 0) return;
            if (i < 3 && this.state[i][j] === this.state[i + 1][j] || j < 3 && this.state[i][j] === this.state[i][j + 1]) return;
        }
        this.status = "lose";
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$export$985739bfa5723e08;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();
const $09e991522ca7e64e$var$controls = document.querySelector(".controls");
const $09e991522ca7e64e$var$score = document.querySelector(".game-score");
const $09e991522ca7e64e$var$buttonStart = document.querySelector(".start");
const $09e991522ca7e64e$var$tbody = document.querySelector("tbody");
const $09e991522ca7e64e$var$lose = document.querySelector(".message-lose");
const $09e991522ca7e64e$var$win = document.querySelector(".message-win");
const $09e991522ca7e64e$var$start = document.querySelector(".message-start");
const $09e991522ca7e64e$var$buttonRestart = document.createElement("button");
$09e991522ca7e64e$var$buttonRestart.classList.add("restart");
$09e991522ca7e64e$var$buttonRestart.classList.add("button");
$09e991522ca7e64e$var$buttonRestart.textContent = "Restart";
$09e991522ca7e64e$var$buttonStart.addEventListener("click", ()=>{
    $09e991522ca7e64e$var$game.start();
    $09e991522ca7e64e$var$start.classList.add("hidden");
    $09e991522ca7e64e$var$updateBoard();
    $09e991522ca7e64e$var$buttonStart.remove();
    $09e991522ca7e64e$var$controls.append($09e991522ca7e64e$var$buttonRestart);
});
$09e991522ca7e64e$var$buttonRestart.addEventListener("click", ()=>{
    $09e991522ca7e64e$var$game.restart();
    $09e991522ca7e64e$var$game.start();
    $09e991522ca7e64e$var$updateBoard();
    $09e991522ca7e64e$var$win.classList.add("hidden");
    $09e991522ca7e64e$var$lose.classList.add("hidden");
});
document.addEventListener("keydown", (e)=>{
    if ($09e991522ca7e64e$var$game.status === "playing") {
        if (e.key === "ArrowLeft") $09e991522ca7e64e$var$game.moveLeft();
        if (e.key === "ArrowRight") $09e991522ca7e64e$var$game.moveRight();
        if (e.key === "ArrowUp") $09e991522ca7e64e$var$game.moveUp();
        if (e.key === "ArrowDown") $09e991522ca7e64e$var$game.moveDown();
        if ($09e991522ca7e64e$var$buttonStart) {
            $09e991522ca7e64e$var$buttonStart.remove();
            $09e991522ca7e64e$var$controls.append($09e991522ca7e64e$var$buttonRestart);
        }
        if ($09e991522ca7e64e$var$game.status === "win") $09e991522ca7e64e$var$win.classList.remove("hidden");
        if ($09e991522ca7e64e$var$game.status === "lose") $09e991522ca7e64e$var$lose.classList.remove("hidden");
        $09e991522ca7e64e$var$updateBoard();
    }
});
function $09e991522ca7e64e$var$updateBoard() {
    $09e991522ca7e64e$var$score.textContent = $09e991522ca7e64e$var$game.getScore();
    const rows = [
        ...$09e991522ca7e64e$var$tbody.querySelectorAll(".field-row")
    ];
    for(let i = 0; i < 4; i++)for(let j = 0; j < 4; j++){
        const cells = [
            ...rows[i].querySelectorAll(".field-cell")
        ];
        if ($09e991522ca7e64e$var$game.getState()[i][j] === 0) {
            cells[j].textContent = null;
            cells[j].className = "field-cell";
        }
        if ($09e991522ca7e64e$var$game.getState()[i][j] !== 0) {
            cells[j].textContent = $09e991522ca7e64e$var$game.getState()[i][j];
            cells[j].className = "field-cell";
            cells[j].classList.add("field-cell--" + $09e991522ca7e64e$var$game.getState()[i][j]);
        }
    }
}


//# sourceMappingURL=index.97e758d0.js.map
